import CityDirectory from "../components/CityDirectory";

export default function UaeCities() {
  return (
    <CityDirectory
      id="uae-cities"
      title="United Arab Emirates City Guides"
      subtitle="All seven emirates — Dubai, Abu Dhabi, Sharjah and the Northern Emirates, from global metropolises to oasis towns and east-coast beaches."
      endpoint="/geo/uae-cities"
      country="UAE"
      searchPlaceholder="Search a city or emirate — try Dubai, Fujairah, Al Ain…"
      accent="#00732f"
      docTitle="UAE City Guides — All Seven Emirates | TravelerPulse"
    />
  );
}
